<template>
  <div>
    <div class="noOrder">
      <div class="inputSearch" v-if="orderList.length">
        <div class="block"></div>
      </div>
      <table
        v-if="orderList.length"
        style="border-collapse: separate; border-spacing: 0px 20px"
      >
        <thead>
          <tr>
            <th v-for="(item, index) in list.title" :key="index">{{ item }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in orderList" :key="index">
            <td class="billdate">{{ item.billdate }}</td>
            <td>{{ item.Number }}</td>
            <td class="money">￥{{ parseFloat(item.Total).toFixed(2) }}</td>
            <td class="tdNoData">
              <div class="payBtn" @click="payment(item.Number)">立即付款</div>
            </td>
            <td class="tdNoData tdW">
              <i
                class="el-icon-document"
                @click="orderListChange(item.Number)"
              ></i>
              <i class="el-icon-delete" @click="deleteOrder(item.Number)"></i>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else><el-empty description="暂无订单数据"></el-empty></div>
      <div class="paginationBox" v-if="orderList.length">
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="index"
            :page-sizes="[10, 15, 20, 25]"
            :page-size="pageSize"
            layout="prev, pager, next, jumper, sizes , total"
            :total="totalSize"
            prev-text="上一页"
            next-text="下一页"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { delbill, getBillList } from "@/api";
import { orderRouter } from "@/router";
export default {
  props: {
    msg: Array,
  },
  data() {
    return {
      list: {
        title: ["订单日期", "采购订单编号", "金额"],
      },
      totalSize: null,
      index: 1, //默认第一页
      pageSize: 10, //默认展示10条数据
      orderList: [],
      orderListAll: [],
    };
  },
  methods: {
    payment(Number) {
      this.$router.addRoutes(orderRouter);
      this.$router.push({
        path: "/orderpay",
        query: {
          Number,
        },
      });
    },
    deleteOrder(Number) {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const h = this.$createElement;
      this.$confirm("订单删除将无法找回，请谨慎操作", "要删除这张订单吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(async () => {
          const { data: res } = await delbill({
            usercode,
            token,
            billno: Number,
          });
          let result = JSON.parse(res)[0];
          if (result.code !== 200) {
            this.$notify.error({
              title: "错误",
              message: result.message,
              duration: 1000,
            });
          } else {
            this.getBillLists();
            this.$notify({
              title: "成功",
              message: result.message,
              type: "success",
            });
          }
        })
        .catch(() => {
          this.$notify.info({
            title: "提示",
            message: "已取消删除",
            duration: 1000,
          });
        });
    },
    orderListChange(Number) {
      this.$router.push({
        path: "/inventory",
        query: {
          type: 0,
          Number,
        },
      });
    },
    async getBillLists() {
      let token = window.sessionStorage.getItem("token");
      let usercode = window.sessionStorage.getItem("usercode");
      const res = await getBillList({
        usercode,
        token,
        flag: "1",
      });
      this.orderListAll = JSON.parse(res.data);
      this.getList();
    },
    getList() {
      this.orderList = this.orderListAll.filter(
        (item, index) =>
          index < this.index * this.pageSize &&
          index >= this.pageSize * (this.index - 1)
      );
      this.totalSize = this.orderListAll.length;
    },
    /**
     * @name: 分页
     */
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.index = val;
      this.getList();
    },
  },
  mounted() {
    this.getBillLists();
  },
  watch: {
    msg(val) {
      this.getBillLists();
    },
  },
};
</script>
<style lang='less' scoped>
.noOrder {
  padding: 30px;
  margin-bottom: 180px;
  .paginationBox {
    padding-top: 40px;
    .block {
      text-align: center;
    }
  }
  .inputSearch {
    text-align: right;
    padding-bottom: 18px;
    border-bottom: 1px dashed #cacbcd;
    .block {
      height: 32px;
    }
  }
  .tdNoData {
    width: 100px !important;
    .payBtn {
      background: #e4040c;
      color: #fff;
      height: 38px;
      border-radius: 2px;
      line-height: 38px;
      cursor: pointer;
    }
    i {
      font-size: 20px;
      display: inline-block;
      padding: 0 10px;
    }
  }
  .tdW {
    width: 130px !important;
  }
  table tr th {
    width: 100px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #747577;
    font-size: 14px;
  }
  table tbody tr {
    background: #fff;
  }
  table tbody tr td {
    width: 303px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  table tbody tr .billdate {
    font-size: 14px;
  }
  table tbody tr {
    .money {
      color: #e5040c;
      font-weight: 600;
    }
  }
}
</style>